export const CompanyFundRouting = [
  {
    path: "/finance/company-fund/list",
    name: "basic-finance-company-fund-list",
    meta: { title: "企业资金账户" },
    component: () =>
      import(
        /* webpackChunkName: "basic-finance-company-fund" */ "@/views/finance/company-fund/list/index.vue"
      ),
  },
];
